import { useCallback } from 'react';

import { useAnalyticsUtilities } from '@air/analytics';

import META from '~/hooks/events/useTrackViewedFavorites.meta';

export const useTrackViewedFavorites = () => {
  const { track } = useAnalyticsUtilities();

  const trackViewedFavorites = useCallback(() => {
    track(META.name);
  }, [track]);

  return { trackViewedFavorites };
};
